import { render, staticRenderFns } from "./image-pop.vue?vue&type=template&id=cfdccafe&scoped=true&"
import script from "./image-pop.vue?vue&type=script&lang=js&"
export * from "./image-pop.vue?vue&type=script&lang=js&"
import style0 from "./image-pop.vue?vue&type=style&index=0&id=cfdccafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdccafe",
  null
  
)

export default component.exports